"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Paragraph = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _slatePlugins = require("@udecode/slate-plugins");
var StyledParagraph = _styledComponents["default"].p.withConfig({
  displayName: "element__StyledParagraph",
  componentId: "sc-8oasv2-0"
})(["font-family:'ONYOneFont','Helvetica',sans-serif;font-size:14px;line-height:17px;color:#17181a;"]);
var Paragraph = exports.Paragraph = function Paragraph(_ref) {
  var element = _ref.element,
    attributes = _ref.attributes,
    children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(StyledParagraph, (0, _extends2["default"])({}, attributes, {
    className: className,
    style: element.style
  }), children);
};
Paragraph.propTypes = {
  children: _propTypes["default"].node,
  attributes: _propTypes["default"].elementType,
  element: _propTypes["default"].shape({
    style: _propTypes["default"].string
  }).isRequired,
  styles: _propTypes["default"].object,
  className: _propTypes["default"].string
};
Paragraph.defaultProps = {
  children: null,
  attributes: [],
  styles: undefined,
  className: ''
};
var defaultParagraph = {
  p: {
    component: Paragraph,
    type: _slatePlugins.ELEMENT_PARAGRAPH,
    rootProps: {
      className: 'slate-p'
    }
  }
};
var _default = exports["default"] = defaultParagraph;